// Firebase configuration with environment variables support
import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase config object - Uses environment variables when available
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyExample-replace-with-your-key",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "your-project.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "your-project-id",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "your-project.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:123456789:web:abcdef123456"
};

// Development mode check
const isDevelopmentMode = process.env.REACT_APP_FIREBASE_DEV_MODE === 'true';

// Initialize Firebase - Only if config is provided or in development mode
let app, db, storage;

try {
  // Check if we have a valid config or are in development mode
  const hasValidConfig = firebaseConfig.apiKey && firebaseConfig.apiKey !== "AIzaSyExample-replace-with-your-key";
  
  if (hasValidConfig || isDevelopmentMode) {
    if (hasValidConfig) {
      // Prevent duplicate Firebase app initialization
      app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
      db = getFirestore(app);
      storage = getStorage(app);
      if (process.env.NODE_ENV === 'development') {
        console.log('🔥 Firebase initialized successfully');
      }
    } else {
      console.warn('🔥 Firebase config not provided. Using mock services for development.');
      // Create mock services for development
      db = null;
      storage = null;
    }
  } else {
    console.error('🔥 Firebase config missing and not in development mode');
    db = null;
    storage = null;
  }
} catch (error) {
  console.error('🔥 Firebase initialization error:', error);
  db = null;
  storage = null;
}

// Export configuration info for debugging
export const firebaseInfo = {
  isInitialized: !!app,
  isDevelopmentMode,
  hasValidConfig: firebaseConfig.apiKey !== "AIzaSyExample-replace-with-your-key",
  projectId: firebaseConfig.projectId
};

export { db, storage };
export default app;
